module.exports = [
    { text: "Masculino", key: "male" },
    { text: "Femenino", key: "female" }]